<template>
  <section class="landing">
    <div class="landing-glow"></div>
    <div class="landing-copy">
      <span class="page-kicker">Authentication infrastructure</span>
      <h1>Ship access control<br><span>without the chaos.</span></h1>
      <p>A focused command center for applications, licenses, secure variables, and release delivery.</p>
      <div class="hero-actions">
        <router-link class="btn primary" to="/login">Open dashboard</router-link>
        <router-link class="btn" to="/register">Request access</router-link>
      </div>
    </div>
    <div class="landing-console" aria-hidden="true">
      <div class="console-head"><span></span><span></span><span></span><small>auth.catnip.dev</small></div>
      <div class="console-body">
        <div class="console-line"><i class="violet"></i><span>Authentication API</span><b>Healthy</b></div>
        <div class="console-line"><i class="cyan"></i><span>License service</span><b>Operational</b></div>
        <div class="console-line"><i class="green"></i><span>Delivery network</span><b>Online</b></div>
        <div class="console-chart"><span v-for="n in 22" :key="n" :style="{height: (20 + ((n * 19) % 62)) + '%'}"></span></div>
      </div>
    </div>
  </section>
</template>

<script>export default { name: 'Home' }</script>

<style scoped>
.landing { min-height: calc(100vh - 76px); max-width: 1280px; margin: auto; padding: 7vh 28px 11vh; display:grid; grid-template-columns: 1.05fr .95fr; gap:7vw; align-items:center; position:relative; }
.landing-glow { position:absolute; width:520px; height:520px; left:-220px; bottom:-220px; background:radial-gradient(circle,rgba(124,92,255,.2),transparent 68%); pointer-events:none; }
.landing-copy { position:relative; z-index:1; }
.landing h1 { margin:0 0 22px; font-size:clamp(48px,6vw,78px); line-height:.98; }
.landing h1 span { color:transparent; background:linear-gradient(100deg,#9f8cff,#61c7ff); background-clip:text; -webkit-background-clip:text; }
.landing p { max-width:580px; color:var(--text-2); font-size:17px; }
.landing-console { position:relative; overflow:hidden; border:1px solid var(--border-strong); border-radius:22px; background:rgba(11,17,29,.8); box-shadow:0 40px 90px rgba(0,0,0,.38); transform:perspective(900px) rotateY(-5deg) rotateX(2deg); }
.landing-console::before { content:""; position:absolute; inset:0; background:linear-gradient(120deg,rgba(124,92,255,.1),transparent 35%); pointer-events:none; }
.console-head { height:48px; display:flex; align-items:center; gap:7px; padding:0 16px; border-bottom:1px solid var(--border); }
.console-head span { width:7px; height:7px; border-radius:50%; background:#32405a; }
.console-head small { margin-left:auto; color:var(--text-3); font-size:9px; letter-spacing:.08em; }
.console-body { padding:28px; }
.console-line { display:grid; grid-template-columns:auto 1fr auto; gap:10px; align-items:center; padding:14px 0; border-bottom:1px solid var(--border); color:var(--text-2); font-size:12px; }
.console-line i { width:8px; height:8px; border-radius:50%; box-shadow:0 0 12px currentColor; }
.console-line .violet { background:#927cff;color:#927cff }.console-line .cyan{background:#39d8ff;color:#39d8ff}.console-line .green{background:#32d49a;color:#32d49a}
.console-line b { color:#7ee7c1; font-size:10px; font-weight:600; }
.console-chart { height:140px; display:flex; align-items:end; gap:5px; padding-top:28px; }
.console-chart span { flex:1; min-height:5%; border-radius:3px 3px 0 0; background:linear-gradient(#8067ff,#425cff); opacity:.72; }
@media(max-width:900px){.landing{grid-template-columns:1fr}.landing-console{display:none}}
</style>
